// extracted by mini-css-extract-plugin
module.exports = {"grid":"ParticipationLayout__grid___3BuV8","right":"ParticipationLayout__right___3CwC2","brief":"ParticipationLayout__brief___2Bezm"};